import React from "react";
import I18n from "lib/i18n";
import PropTypes from "prop-types";
import analyticsURL from "lib/analyticsURL";

const AnalyticsLink = ({ visible }) => {
  if (visible) {
    return (
      <React.Fragment>
        <li className="metrics">
          <a href={analyticsURL()}>{I18n.t("top_bar.label.analytics")}</a>
        </li>
      </React.Fragment>
    );
  }

  return null;
};

AnalyticsLink.propTypes = {
  visible: PropTypes.bool.isRequired,
};

export default AnalyticsLink;
